var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a-modal', {
    attrs: {
      "title": "申请退款",
      "width": 600,
      "dialog-style": {
        top: '20px'
      },
      "maskClosable": false,
      "keyboard": false,
      "visible": _vm.visible,
      "footer": null
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_vm.eventApplyInfo.event ? _c('p', [_vm._v("活动： " + _vm._s(_vm.eventApplyInfo.event.eventName))]) : _vm._e(), _vm.eventApplyInfo.categoryParent ? _c('p', [_vm._v("赛项： " + _vm._s(_vm.eventApplyInfo.categoryParent.name))]) : _vm._e(), _vm.eventApplyInfo.category ? _c('p', [_vm._v("组别： " + _vm._s(_vm.eventApplyInfo.category.name))]) : _vm._e(), _c('p', [_vm._v("订单号：" + _vm._s(_vm.orderInfo.orderNo))]), _c('p', [_vm._v("金额：" + _vm._s(_vm.orderInfo.payPrice / 100))]), _c('p', [_vm._v("请填写退款理由：")]), _c('a-textarea', {
    model: {
      value: _vm.comment,
      callback: function callback($$v) {
        _vm.comment = $$v;
      },
      expression: "comment"
    }
  }), _c('a-button', {
    staticStyle: {
      "display": "block",
      "margin": "20px auto",
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "disabled": _vm.canRefund
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v("确认申请退款")])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };